import { NullError } from "shared-ts-utils-core";
import { AccountInfo } from "@azure/msal-browser";
import { User } from "shared-ts-utils-authentication";

export class MsalUser implements User {
  private readonly accountInfo: AccountInfo;

  constructor(accountInfo: AccountInfo) {
    if (accountInfo == null) {
      throw new NullError("accountInfo");
    }
    this.accountInfo = accountInfo;
  }

  get id(): string {
    return this.accountInfo.homeAccountId ?? "?";
  }
  get name(): string {
    return this.accountInfo.name ?? "?";
  }
  get email(): string {
    return "?";
  }

  get accessToken(): string {
    return this.accountInfo.idToken ?? "?";
  }

  hasClaim(claim: string): boolean {
    // TODO
    return false;
  }

  hasRole(role: string): boolean {
    // TODO
    return false;
  }

  getRole(): string {
    throw new Error("Method not implemented.");
  }

  isSessionActive(): boolean {
    // TODO
    return true;
  }

  isAirmontEmployee(): boolean {
    return this.email.endsWith("@airmont.no");
  }
}
